import { COMPLETE_REVIEW, DOCUMENTS_DROP_DOWN, GET_DRAFTED_DETAILS, GET_SIGNED_URL, GLOSSARY_DROP_DOWN, HTML_TEXT_BLOCKS, LIST_POST_EDITING, PDF_TEXT_BLOCKS, POST_EDIT_WORD, PPTX_TEXT_BLOCKS, PUBLISH_DOC, SEND_POST_EDITING, SEND_TO_MODEL, TRANSLATE_DOCUMENT, TRANSLATE_FILE, TRANSLATE_HTML_FILE, TRANSLATE_MORE_PAGES, TRANSLATION_JOBS, TRANSLATiON_JOBS, TRANSLATION_JOBS_VIEW, UPDATE_HTML_DOCUMENT, UPDATE_PDF_DOCUMENT, UPDATE_POST_EDIT_JOB, UPDATE_PPTX_DOCUMENT, UPDATE_WORD_DOCUMENT, VIEW_DOCUMENT, WORD_TEXT_BLOCKS } from "./types";

export const glossaryDropDownAction = (data, onSuccess, onError) => {
    return {
        type: GLOSSARY_DROP_DOWN,
        data,
        onSuccess,
        onError,
    };
};

export const documentsDropDownAction = (data, onSuccess, onError) => {
    return {
        type: DOCUMENTS_DROP_DOWN,
        data,
        onSuccess,
        onError,
    };
};

export const getSignedUrlAction = (data, onSuccess, onError) => {
    return {
        type: GET_SIGNED_URL,
        data,
        onSuccess,
        onError,
    };
};

export const translateDocAction = (data, onSuccess, onError) => {
    return {
        type: TRANSLATE_DOCUMENT,
        data,
        onSuccess,
        onError,
    };
};

export const viewDocAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_DOCUMENT,
        data,
        onSuccess,
        onError,
    };
};

export const translationsJobsListAction = (data, onSuccess, onError) => {
    return {
        type: TRANSLATION_JOBS,
        data,
        onSuccess,
        onError,
    };
};

export const viewTranslationsJobAction = (data, onSuccess, onError) => {
    return {
        type: TRANSLATION_JOBS_VIEW,
        data,
        onSuccess,
        onError,
    };
};

export const PublishDocAction = (data, onSuccess, onError) => {
    return {
        type: PUBLISH_DOC,
        data,
        onSuccess,
        onError,
    };
};

export const sendPostEditingAction = (data, onSuccess, onError) => {
    return {
        type: SEND_POST_EDITING,
        data,
        onSuccess,
        onError,
    };
};

export const postEditingListAction = (data, onSuccess, onError) => {
    return {
        type: LIST_POST_EDITING,
        data,
        onSuccess,
        onError,
    };
};

export const postEditWordAction = (data, onSuccess, onError) => {
    return {
        type: POST_EDIT_WORD,
        data,
        onSuccess,
        onError,
    };
};

export const completeReviewAction = (data, onSuccess, onError) => {
    return {
        type: COMPLETE_REVIEW,
        data,
        onSuccess,
        onError,
    };
};


export const getWordTextBlocksAction = (data, onSuccess, onError) => {
    return {
        type: WORD_TEXT_BLOCKS,
        data,
        onSuccess,
        onError,
    };
};

export const getPptxTextBlocksAction = (data, onSuccess, onError) => {
    return {
        type: PPTX_TEXT_BLOCKS,
        data,
        onSuccess,
        onError,
    };
};

export const getPDFTextBlocksAction = (data, onSuccess, onError) => {
    return {
        type: PDF_TEXT_BLOCKS,
        data,
        onSuccess,
        onError,
    };
};

export const getHtmlTextBlocksAction = (data, onSuccess, onError) => {
    return {
        type: HTML_TEXT_BLOCKS,
        data,
        onSuccess,
        onError,
    };
};

export const updateWordFileAction = (data, onSuccess, onError) => {
    return {
        type: UPDATE_WORD_DOCUMENT,
        data,
        onSuccess,
        onError,
    };
};

export const updatePptxFileAction = (data, onSuccess, onError) => {
    return {
        type: UPDATE_PPTX_DOCUMENT,
        data,
        onSuccess,
        onError,
    };
};

export const updatePDFFileAction = (data, onSuccess, onError) => {
    return {
        type: UPDATE_PDF_DOCUMENT,
        data,
        onSuccess,
        onError,
    };
};

export const updateHtmlFileAction = (data, onSuccess, onError) => {
    return {
        type: UPDATE_HTML_DOCUMENT,
        data,
        onSuccess,
        onError,
    };
};

export const sendToModelAction = (data, onSuccess, onError) => {
    return {
        type: SEND_TO_MODEL,
        data,
        onSuccess,
        onError,
    };
};

export const draftedDetailsAction = (data, onSuccess, onError) => {
    return {
        type: GET_DRAFTED_DETAILS,
        data,
        onSuccess,
        onError,
    };
};

export const translateHtmlFileAction = (data, onSuccess, onError) => {
    return {
        type: TRANSLATE_HTML_FILE,
        data,
        onSuccess,
        onError,
    };
};

export const translateMorePagesAction = (data, onSuccess, onError) => {
    return {
        type: TRANSLATE_MORE_PAGES,
        data,
        onSuccess,
        onError,
    };
};

export const updatePostEditJobAction = (data, onSuccess, onError) => {
    return {
        type: UPDATE_POST_EDIT_JOB,
        data,
        onSuccess,
        onError,
    };
};

export const translateFileAction = (data, onSuccess, onError) => {
    return {
        type: TRANSLATE_FILE,
        data,
        onSuccess,
        onError,
    };
};